import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ISlimScrollOptions } from 'ng2-slimscroll';
import * as _ from 'lodash';

import { AppService } from '../../app.service';
import { FacilityService } from './../facility.service';
import {
  MessageEvent, SignInEvent, LoaderEvent, OpenFrameEvent, SidemenuToViewFacilityEvent,
  SidemenuSubCategory, HiddenFooter
} from './../../shared/message.event';

import { Facility } from '../facility';
import { FacilityValidation } from './facility-validation';
import { UISETTING } from './../../shared/ui-setting';
import { FacilityBase } from './facility-base';
import { UtilityFunctions } from '../../shared/utility-functions';

import { CONSTANT_MESSAGES } from '../../constants/constants-messages';
import { CONSTANT_VALUES } from '../../constants/constant-values';

@Component({
  selector: 'app-facility-rule',
  templateUrl: './facility-rule.component.html',
  styleUrls: ['./facility-rule.component.css'],
  providers: [FacilityService, MessageEvent, SignInEvent, LoaderEvent, OpenFrameEvent, SidemenuToViewFacilityEvent,
    SidemenuSubCategory, HiddenFooter, UtilityFunctions]
})
export class FacilityRuleComponent extends FacilityBase implements OnInit {
  @ViewChild("butt1") butt1;
  @ViewChild("butt2") butt2;
  @ViewChild("butt3") butt3;
  @ViewChild("butt4") butt4;
  @ViewChild("butt5") butt5;
  @ViewChild("butt6") butt6;
  @ViewChild("butt7") butt7;
  @ViewChild("butt8") butt8;
  @ViewChild("butt9") butt9;
  @ViewChild("butt10") butt10;
  @ViewChild("butt11") butt11;
  @ViewChild("butt12") butt12;
  @ViewChild("butt13") butt13;
  @ViewChild("butt14") butt14;
  @ViewChild("butt15") butt15;
  @ViewChild("butt16") butt16;
  @ViewChild("butt17") butt17;
  @ViewChild("butt18") butt18;
  // @ViewChild("butt19") butt19;
  // @ViewChild("butt20") butt20;
  @ViewChild("butt21") butt21;
  @ViewChild("butt22") butt22;
  @ViewChild("butt23") butt23;
  @ViewChild("butt24") butt24;
  @ViewChild("butt25") butt25;
  @ViewChild("butt26") butt26;
  @ViewChild("butt27") butt27;
  @ViewChild("butt28") butt28;
  @ViewChild("butt29") butt29;
  @ViewChild("butt30") butt30;
  @ViewChild("butt31") butt31;
  @ViewChild("butt32") butt32;
  private facilityType = CONSTANT_VALUES.FACILITY_TYPE;
  private iconList = CONSTANT_VALUES.ICON_LIST.sort();
  private entries = CONSTANT_VALUES.ENTRIES;
  private unitList = CONSTANT_VALUES.UNIT_LIST;
  private holdbookingdays = CONSTANT_VALUES.HOLDBOOKINGDAYS;
  private notificationPeriod = CONSTANT_VALUES.NOTIFICATION_PERIOD;
  private shouldSlide: boolean = false;
  private facility: Facility;
  private facilityArray = [];
  private facility_list = [];
  private defaultValue = false;
  private iconImage;
  private saveFlag = false;
  private popupTitle = 'Error';
  private popUpMessage: any = '';
  private currentCategory = {};
  private vendor;
  private cancleButton = false;
  private deleteMessage = false;
  private endTimeList = CONSTANT_VALUES.TIMINGS_END;
  private cancleFlag = false;
  private functionHallFlag = false;
  private scrollOptions: ISlimScrollOptions;
  private viewIcon = {
    name: '',
    iconClass: ''
  };
  private tempFacilityId = '';
  private redirectConfirmationMessage = '';
  private facilityValidationObj;
  private uiSetting: UISETTING;
  private height: any;
  private amenitiesFlag;
  private booking_unit_list = CONSTANT_VALUES.BOOKING_UNIT;
  private hour_values = CONSTANT_VALUES.HOUR_VALUES;
  private minute_values = CONSTANT_VALUES.MINUTE_VALUES;
  private bookingUnit_hour;
  private bookingUnit_minute;
  private activity_end_time_hours = CONSTANT_VALUES.HOUR_VALUES_ACTIVITY_END_TIME;

  constructor(private router: Router, private facilityService: FacilityService,
    private openFrameEvent: OpenFrameEvent, private messageEvent: MessageEvent, private signInEvent: SignInEvent,
    private appService: AppService, private loaderEvent: LoaderEvent, private sidemenuSubCategory: SidemenuSubCategory,
    private sidemenuToViewFacilityEvent: SidemenuToViewFacilityEvent, private hiddenFooter: HiddenFooter, private utilityFunctions: UtilityFunctions) {
    super();
    this.uiSetting = {
      'windowHeight': window.innerHeight,
      'topNav': 56,
      'midNav': 45,
      'footer': 35,
      'container': 80
    }
    this.facilityValidationObj = new FacilityValidation(appService, utilityFunctions);
    this.isReadOnly = false;
    this.editStatus = false;
    this.defaultValue = false;
    this.closeTimeArray = [];
    this.openTime_hour = '';
    this.openTime_minute = '';
    this.closeTime_hour = '';
    this.closeTime_minute = '';
    this.peekStartTime = '';
    this.peekStartTime_hour = '';
    this.peekStartTime_minute = '';
    this.peekEndTime = '';
    this.peekEndTime_hour = '';
    this.peekEndTime_minute = '';
    this.closedStartTime = '';
    this.closedStartTime_hour = '';
    this.closedStartTime_minute = '';
    this.closedEndTime = '';
    this.closedEndTime_hour = '';
    this.closedEndTime_minute = '';
    this.facility = {
      'name': '',
      'noOfUnits': '',
      'slotDuration': '',
      'category': '',
      'timings': {
        'openTime': '',
        'closeTime': ''
      },
      'unitNames': [],
      'icon': '',
      'isChargable': false,
      'amount': {
        'currency': 'USD',
        'value': ''
      },
      'isHoldBooking': false,
      'holdBookingDays': '',
      'isAttendeeCountRequired': false,
      'reminder': {
        'unit': 'hours',
        'value': ''
      },
      'maxWeekdayBooking': '',
      'maxWeekendBooking': '',
      'isWaitlistEnabled': false,
      'isMaxBookingsPerSlot': false,
      'waitlistCount': '',
      'maxBookingsPerSlot': '',
      'vendorId': '',
      'isActive': true,
      'peekStartTime': '',
      'peekEndTime': '',
      'maxBookingHoursWeekday': '',
      'maxBookingHoursWeekend': '',
      'maxNumberOfPeopleWeekday': '',
      'maxNumberOfPeopleWeekend': '',
      'notificationAcceptanceHour': '',
      'peakUnitsCount': '',
      'createdBy': '',
      'breakTimings': [],
      'peekTimings': [],
      'isMaxBookingPerMembership': false,
      'isMaxBookingPerPerson': false,
      'timezoneOffset': new Date().getTimezoneOffset(),
      'isPeakTimeEnabled': true,
      'isBreakTimeEnabled': true,
      'maxBookingHoursMonth': '',
      'notes': '',
      'isAllowMemberNotes': false,
      'memberNotesHintText': '',
      'vendorNotesHintText': '',
      'isAllowVendorNotes': false,
      'isAllowForceBooking': false,
      'isCourtSelection': false,
      'isOpenBookingOnFriday': false,
      'isSlotsLocked': true,
      'isOpenNextMonthBooking': false,
      'activitySlots': [],
      'isCreatedForGroup': false,
      'isWeeklyRepeatBooking': false,
      'isGSTApplicable': false,
      'GSTValue': '',
      'showEventActivity': true  // Add this property
    };
    this.scrollOptions = {
      barBackground: "#333", barOpacity: "0.6", position: "right",
      barWidth: "6px", barBorderRadius: "5px"
    };
    // calculating height of current frame
    this.height = (this.uiSetting.windowHeight - (this.uiSetting.topNav + this.uiSetting.midNav + this.uiSetting.container + this.uiSetting.footer)) + 'px';
    this.iconImage = JSON.parse(JSON.stringify(CONSTANT_VALUES.ICON_LIST_IMAGE));
    this.redirectConfirmationMessage = CONSTANT_MESSAGES.REDIRECT_FROM_ACTIVITY;
    this.bookingUnit_hour = '';
    this.bookingUnit_minute = '';

  }

  ngAfterContentInit() {
  }
  /**
   * Show Facility object stored in local storage iff vendor is login
   *
   * @param vendor and facility object
   *
   * @response facility view
   */

  ngOnInit() {
    this.emitOpenFrameEvent();
    this.pageName = 'Activity Rules';
    if (localStorage.getItem('vendor')) {
      this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
      if (this.vendor.role == CONSTANT_VALUES.SUPER_ADMIN) {
        if (this.vendor.subVendors.length > 0) {
          let subVendor = this.vendor.subVendors[0];
          this.clubName = subVendor.clubName;
        }
      } else {
        this.clubName = this.vendor.clubName;
      }
    }

    this.setFrameForFacilityRules();
    this.emitTypeBroadcast();
    this.registerTypeBroadcast();
  }

  /**
   * Add new facility
   *
   * @param  facility object
   *
   * @response SUCCESS or FAILED
   */

  addFacility(popUpObj) {
    try {
      this.loaderEvent.fire(false);
      this.cancleButton = true;
      this.saveFlag = true;
      let t = this.facilityValidationObj.validateFacilityObj(this);
      if (t) {
        this.facility.name = (this.facility.name + '').trim();
        this.facility.notes = (this.facility.notes).trim();
        if (this.facility.maxBookingsPerSlot == "") {
          this.facility.maxBookingsPerSlot = "1";
        }
        let a = this.facilityService.validateFunctionality(this.facility.timings, this.closeTimeArray,
          this.peekTimingsArray, this.facility.isPeakTimeEnabled, this.facility.isBreakTimeEnabled,
          this.bookingUnit_hour, this.bookingUnit_minute, this.facility.category);
        if (a.status === 300) {
          this.setFacilityData();
          this.facilityService.addFacility(this.facility)
            .then((result: any) => {
              if (result.status === 'SUCCESS') {
                this.router.navigate(['/facility']);
              } else {
                this.loaderEvent.fire(true);
                this.popUpMessage = result.message;
                popUpObj.showChildModal();
              }
            });
          this.loaderEvent.fire(true);
        } else {
          this.loaderEvent.fire(true);
          this.popUpMessage = a.message;
          popUpObj.showChildModal();
        }
      } else {
        this.loaderEvent.fire(true);
      }
    } catch (e) {
      console.log(e);
    }
  }

  /**
   * Redirecting to Facility page
   */

  cancelFacility(popUpObj) {
    if (this.facility.category || this.facility.name || this.unitNames || this.facility.noOfUnits || this.openTime_hour || this.openTime_minute || this.closeTime_hour ||
      this.closeTime_minute || this.facility.slotDuration || this.facility.reminder.value || this.facility.notificationAcceptanceHour || this.facility.icon) {
      this.popUpMessage = this.redirectConfirmationMessage;
      popUpObj.showChildModal();
    } else {
      this.confirmationForDataLoss(true);
    }

  }

  /**
   * function show menu at facility page by broadcaster
   */

  emitTypeBroadcast() {
    let isShow = {
      privacypolicy: true,
      support: false,
      footer: 'block'
    };
    this.signInEvent.fire('block');
    this.hiddenFooter.fire(isShow);
  }

  emitOpenFrameEvent() {
    this.openFrameEvent.fire(false);
  }

  /**
   * while menu slide left to right as well as we shift header, footer and body too like menu by broadcaster
   */

  registerTypeBroadcast() {
    this.messageEvent.on()
      .subscribe(message => {
        this.shouldSlide = message;
      });
    this.sidemenuToViewFacilityEvent.on()
      .subscribe(message => {
        this.currentCategory = message;
        localStorage.setItem('currentCategory', btoa(message));
        this.pageName = 'Facility Rules';
        this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
        this.addFacilityStatus = false;
        this.viewFacility('category');
      });
  }

  /**
   * View selected facility
   *
   * @param  facility object from local storage
   *
   * @response Facility object not found
   */

  viewFacility(frameName) {
    this.iconImage = JSON.parse(JSON.stringify(CONSTANT_VALUES.ICON_LIST_IMAGE));
    this.setFlagBeforeViewFacility(this);
    this.setFacilityForView(frameName);
    this.setTo24();
    for (let iconObj of this.iconImage) {
      if (this.facility.icon === iconObj.name) {
        this.viewIcon.name = iconObj.name;
        this.viewIcon.iconClass = iconObj.iconClass;
        break;
      }
    }

    if (
  this.facility.unitNames &&
  Array.isArray(this.facility.unitNames) &&
  this.facility.unitNames.length > 0 &&
  typeof this.facility.unitNames[0] === 'string'
) {
  this.unitNames = this.facility.unitNames[0].split('-')[0];
}



    if (this.facility) {
      let obj = {
        category: this.facility.category,
        menu: 'Activities'
      };
      this.setLocalFlagWithFacilityRules(this);
      this.sidemenuSubCategory.fire(obj);
      this.iconImage = CONSTANT_VALUES.ICON_LIST_IMAGE;
      this.setDefaultValues(this);
      this.setTimingsForFacility(this);
      if (this.checkAmenities()) {
        this.facility.slotDuration = '';
        this.bookingUnit_hour = '';
        this.bookingUnit_minute = '';
        this.functionHallFlag = true;
      } else {
        this.setBookingUnit();

      }
      if (!this.facility.isPeakTimeEnabled) {
        this.facility.peakUnitsCount = '';
      }
      // this.setGtmTime();
      this.setToggleForViewFacility();

      this.disableBookingUnit();
      this.facilityValidationObj.validateFacilityObj(this);
    } else {
      this.loaderEvent.fire(false);
      this.router.navigate(['/facility']);
    }
  }

  /**
   * update facility
   *
   * @param  facility object
   *
   * @response SUCCESS or FAILED
   */

  updateFacility(popUpObj) {
    try {
      this.loaderEvent.fire(false);
      this.cancleButton = true;
      let t = this.facilityValidationObj.validateFacilityObj(this);
      if (t) {
        this.facility.name = (this.facility.name + '').trim();
        this.facility.notes = (this.facility.notes).trim();
        if (this.facility.maxBookingsPerSlot == "") {
          this.facility.maxBookingsPerSlot = "1";
        }
        let a = this.facilityService.validateFunctionality(this.facility.timings, this.closeTimeArray,
          this.peekTimingsArray, this.facility.isPeakTimeEnabled, this.facility.isBreakTimeEnabled, this.bookingUnit_hour, this.bookingUnit_minute, this.facility.category);
        if (a.status === 300) {
          this.setFacilityData();
          this.facilityService.updateFacility(this.facility)
            .then((result: any) => {
              if (result.status === 'SUCCESS') {
                localStorage.removeItem('facility');
                this.loaderEvent.fire(true);
                this.router.navigate(['/facility']);
              } else {
                this.loaderEvent.fire(true);
                this.popUpMessage = result.message;
                popUpObj.showChildModal();
              }
            });
        } else {
          this.loaderEvent.fire(true);
          this.popUpMessage = a.message;
          popUpObj.showChildModal();
        }
      } else {
        this.loaderEvent.fire(true);
      }
    } catch (err) {
      console.log(err);
    }
  }

  /**
   * Redirecting to member page
   */

  homeScreen(popUpObj) {
    try {
      if ((this.facility.category || this.facility.name || this.unitNames || this.facility.noOfUnits || this.openTime_hour || this.openTime_hour || this.closeTime_hour || this.closeTime_minute
        || this.facility.slotDuration || this.facility.reminder.value || this.facility.notificationAcceptanceHour || this.facility.icon) && this.editStatus) {
        this.popUpMessage = this.redirectConfirmationMessage;
        popUpObj.showChildModal();
      } else {
        this.dataResetWhileHomeScreen(true);
      }
    } catch (err) {
      console.log(err);
    }
  }

  /**
       * Get facility list by Category
       *
       * @param  Category name
       *
       * @response Facility List
       */

  showFacilityByCategory(catagory) {
    try {
      let vendor_facility_list = [];
      vendor_facility_list = JSON.parse((localStorage.getItem('vendor_facilityData')));
      for (let obj of vendor_facility_list) {
        if (obj.categoryName === catagory) {
          this.facility_list = obj.data;
          break;
        }
      }
    } catch (err) {
      console.log(err);
    }
  }

  /**
       * Show Facility
       *
       * @param  Facility Id
       *
       * @response Facility Object
       */

  showFacility(facilityId) {
    this.tempFacilityId = facilityId;
    let facility = {};
    this.closeTimeArray = [];
    this.peekTimingsArray = [];
    this.changeStatusATView();
    facility = this.facility_list.filter(function (rec) {
      if (rec._id === facilityId) {
        return rec;
      }
    });
    localStorage.setItem('facility', JSON.stringify(facility[0]));
    this.viewFacility('facility');
  }

  /**
  *
  * Soft delete facility from Database
  */

  deleteFacility() {
    try {
      let facility = JSON.parse(this.appService.getFacility());
      let deleteFacilityObj = {
        'facilityId': facility._id,
        'vendorId': ''
      }
      if (this.vendor.subVendors.length > 0) {
        let subvendor = this.vendor.subVendors[0];
        deleteFacilityObj.vendorId = subvendor._id;
      }
      this.loaderEvent.fire(false);
      this.facilityService.deleteFacility(deleteFacilityObj).then((result: any) => {
        if (result.status === 'SUCCESS') {
          this.router.navigate(['/facility']);
        } else {
          this.loaderEvent.fire(true);
          this.popUpMessage = result.message;
        }
      }).catch((err) => {
        console.log(err);
        this.loaderEvent.fire(true);
      });
    } catch (err) {
      this.loaderEvent.fire(true);
      console.log(err);
    }
  }

  /**
  * When Facilities within category showing in view mode
  */
  changeStatusATView() {
    try {
      this.isReadOnly = true;
      this.editStatus = false;
      this.setDefaultValues(this);
    } catch (err) {
      console.log(err);
    }
  }

  /**
  * Cancle button showing on confirmation popup
  */
  changeCancleButton(popUpObj) {
    try {
      if (this.deleteMessage) {
        this.popupTitle = 'Delete Confirmation';
        this.popUpMessage = CONSTANT_MESSAGES.DELETE_CONFIRMATION;
      } else {
        this.popupTitle = 'Edit Confirmation';
        this.popUpMessage = CONSTANT_MESSAGES.EDIT_CONFIRMATION;
      }
      this.cancleButton = false;
      this.cancleFlag = true;
      popUpObj.showChildModal();
    } catch (err) {
      console.log(err);
    }
  }

  /**
  * Confirmation for delete facility
  */
  confirmationFromVendor(message: boolean): void {
    try {
      if (message === true) {
        if (this.deleteMessage) {
          this.deleteFacility();
          this.deleteMessage = false;
          return;
        } else {
          this.router.navigate(['/facility']);
        }
        if (this.saveFlag) {
          this.router.navigate(['/addfacility']);
        }
        if (this.cancleFlag) {
          this.router.navigate(['/facility']);
          this.cancleFlag = false;
        }
      } else {
        this.deleteMessage = false;
        this.router.navigate(['/addfacility']);
      }
    } catch (err) {
      console.log(err);
    }
  }

  /**
  * Set flag if vendor have to delete facility
  */

  confirmDelete() {
    this.deleteMessage = true;
  }

  /**
   * Disable booking unit fields for amemeties
   */

  disableBookingUnit() {
    if (this.checkAmenities()) {
      this.bookingUnit_hour = '';
      this.bookingUnit_minute = '';
      this.setFlagsForDisableBookings(this);
      this.setToggleClass('butt14', 'butt13');
    } else {
      this.functionHallFlag = false;
    }
  }

  /**
   * Set peek unit time to blank.
   * @memberof FacilityRuleComponent
   */

  setPeekUnit() {
    this.facility.peakUnitsCount = '';
  }
  /**
   * Remove unnecessary items from local storage before moving to other option from edit mode
   *
   * @param {Boolean} bool
   *
   * @memberof FacilityRuleComponent
   */
  confirmationForDataLoss(bool: Boolean) {
    if (bool) {
      if (localStorage.getItem('vendor')) {
        localStorage.removeItem('facility');
        localStorage.removeItem('currentCategory');
        this.router.navigate(['/facility']);
      }
    }
  }
  /**
   * Remove unnecessary items from local storage before moving to home page
   *
   * @param {Boolean} bool
   *
   * @memberof FacilityRuleComponent
   */
  dataResetWhileHomeScreen(bool: Boolean) {
    if (bool) {
      if (localStorage.getItem('vendor')) {
        localStorage.removeItem('facility');
        localStorage.removeItem('currentCategory');
        this.utilityFunctions.homeScreen(this);
      }
    }
  }
  /**
   * Confirmation popup for change activity
   *
   * @param {any} facilityId
   * @param {any} popUpObj
   *
   * @memberof FacilityRuleComponent
   */
  confirmForChangeActivity(facilityId, popUpObj) {
    this.tempFacilityId = facilityId;
    if (this.editStatus) {
      this.popUpMessage = this.redirectConfirmationMessage;
      popUpObj.showChildModal();
    } else {
      this.showFacility(this.tempFacilityId);
    }
  }
  /**
   * Set current facility Id.
   *
   * @param {any} facilityId
   *
   * @memberof FacilityRuleComponent
   */
  saveFacilityId(facilityId) {
    this.tempFacilityId = facilityId;
  }
  /**
   * Change css class as per toggle button set
   *
   * @param {any} toggleOwn
   * @param {any} toggleOther
   *
   * @memberof FacilityRuleComponent
   */

  changeClassForToggle(toggleOwn, toggleOther) {
    toggleOwn.classList.remove('btn-toggle2');
    toggleOwn.classList.add('btn-toggle1');
    toggleOther.classList.remove('btn-toggle1');
    toggleOther.classList.add('btn-toggle2');
  }
  /**
   * Set css class as per facility rule inv view mode
   *
   * @param {any} but1
   * @param {any} but2
   *
   * @memberof FacilityRuleComponent
   */
  setToggleClass(but1, but2) {
    let element1 = this[but1].nativeElement;
    let element2 = this[but2].nativeElement;
    element1.classList.remove('btn-toggle1');
    element2.classList.remove('btn-toggle2');
    element1.classList.add('btn-toggle2');
    element2.classList.add('btn-toggle1');
  }

  setToggleForViewFacility() {
    if (this.facility.isAttendeeCountRequired) {
      this.setToggleClass('butt1', 'butt2');
    } else {
      this.setToggleClass('butt2', 'butt1');
    }
    if (this.facility.isWaitlistEnabled) {
      this.setToggleClass('butt3', 'butt4');
    } else {
      this.setToggleClass('butt4', 'butt3');
    }
    if (this.facility.isMaxBookingsPerSlot) {
      this.setToggleClass('butt7', 'butt8');
    } else {
      this.setToggleClass('butt8', 'butt7');
    }
    if (this.facility.isChargable) {
      this.setToggleClass('butt5', 'butt6');
    } else {
      this.setToggleClass('butt6', 'butt5');
    }
    if (this.facility.isMaxBookingPerMembership) {
      this.setToggleClass('butt9', 'butt10');
    } else {
      this.setToggleClass('butt10', 'butt9');
    }
    if (this.facility.isMaxBookingPerPerson) {
      this.setToggleClass('butt11', 'butt12');
    } else {
      this.setToggleClass('butt12', 'butt11');
    }
    if (this.facility.isPeakTimeEnabled) {
      this.setToggleClass('butt13', 'butt14');
    } else {
      this.setToggleClass('butt14', 'butt13');
    }
    if (this.facility.isBreakTimeEnabled) {
      this.setToggleClass('butt15', 'butt16');
    } else {
      this.setToggleClass('butt16', 'butt15');
    }
    if (this.facility.isAllowForceBooking) {
      this.setToggleClass('butt17', 'butt18');
    } else {
      this.setToggleClass('butt18', 'butt17');
    }
    // if (this.facility.isCourtSelection) {
    //   this.setToggleClass('butt19', 'butt20');
    // } else {
    //   this.setToggleClass('butt20', 'butt19');
    // }
    if (this.facility.isOpenBookingOnFriday) {
      this.setToggleClass('butt21', 'butt22');
    } else {
      this.setToggleClass('butt22', 'butt21');
    }
    if (this.facility.isSlotsLocked) {
      this.setToggleClass('butt23', 'butt24');
    } else {
      this.setToggleClass('butt24', 'butt23');
    }
    if (this.facility.isOpenNextMonthBooking) {
      this.setToggleClass('butt25', 'butt26');
    } else {
      this.setToggleClass('butt26', 'butt25');
    }
    if (this.facility.isCreatedForGroup) {
      this.setToggleClass('butt27', 'butt28');
    } else {
      this.setToggleClass('butt28', 'butt27');
    }
    if (this.facility.isWeeklyRepeatBooking) {
      this.setToggleClass('butt29', 'butt30');
    } else {
      this.setToggleClass('butt30', 'butt29');
    }
    if (this.facility.isGSTApplicable) {
      this.setToggleClass('butt31', 'butt32');
    } else {
      this.setToggleClass('butt32', 'butt31');
    }
  }
  /**
   * Set facility for view
   *
   * @param {any} frameName
   *
   * @memberof FacilityRuleComponent
   */
  setFacilityForView(frameName) {
    if (frameName === 'facility') {
      this.facility = JSON.parse(this.appService.getFacility());
      this.showFacilityByCategory(this.facility.category);
    } else if (frameName === 'category') {
      this.showFacilityByCategory(this.currentCategory);
      this.appService.storeFacility(this.facility_list[0]);
      this.facility = JSON.parse(this.appService.getFacility());
    }
  }

  setFrameForFacilityRules() {
    if (localStorage.getItem('facility')) {
      this.viewFacility('facility');
      this.facilityArray = JSON.parse(localStorage.getItem('facilityList'));
    } else if (localStorage.getItem('currentCategory')) {
      this.currentCategory = atob(localStorage.getItem('currentCategory'));
      this.viewFacility('category');
    } else {
      this.pageName = 'Add New Activity';
      this.addFacilityStatus = true;
    }
  }

  changeClass() {
    let element = this['butt3'].nativeElement;
    element.classList.add('required');
  }
  checkAmenities() {
    let that = this;
    if (_.indexOf(CONSTANT_VALUES.AMENITIES, that.facility.category) >= 0) {
      this.amenitiesFlag = true;
      return true;
    } else {
      this.amenitiesFlag = false;
      return false;
    }
  }

  convertBookingUnitIntoMin(bookingUnit) {
    let bookingTime = bookingUnit.split(':');
    let hour = parseInt(bookingTime[0]);
    let min = parseInt(bookingTime[1]);
    return (hour * 60 + min + '').toString();
  }

  calculateSlotDuration() {
    let slotDuration = parseInt(this.bookingUnit_hour) * 60 + parseInt(this.bookingUnit_minute);
    return slotDuration.toString();
  }

  setBookingUnit() {
    let slotDuration = this.facility.slotDuration;
    let hour = ('0' + Math.floor(parseInt(slotDuration) / 60)).slice(-2);
    let min = ('0' + parseInt(slotDuration) % 60).slice(-2);
    this.bookingUnit_hour = hour;
    this.bookingUnit_minute = min;
  }

  calculateBookingStartTimeValues() {
    const openTime = this.facility.timings.openTime.split(':');
    const slotDuration = this.checkAmenities() ? 60 : parseInt(this.facility.slotDuration);
    const openTimeMin = parseInt(openTime[0]) * 60 + parseInt(openTime[1]);
    let hour;
    let minute;
    let nextBookingSlot = openTimeMin;
    let breakTimeMinArray = [];
    let temp, that = this;
    let actualArr = [];
    let breakTimings = [];
    breakTimings.push({ start: this.facility.timings.openTime, end: this.facility.timings.openTime });
    if (this.facility.breakTimings.length > 0) {
      breakTimings = breakTimings.concat(this.facility.breakTimings);
    }
    breakTimings.push({ start: this.facility.timings.closeTime, end: this.facility.timings.closeTime });
    breakTimings.forEach(element => {
      temp = that.computeMin(element);
      breakTimeMinArray.push(temp);
    });
    breakTimeMinArray = this.sortOnBookingStart(breakTimeMinArray);
    let i = 0;
    let str;
    while (i < breakTimeMinArray.length - 1) {
      if (breakTimeMinArray[i].end <= (nextBookingSlot + slotDuration) && (slotDuration + nextBookingSlot) <= breakTimeMinArray[i + 1].start && nextBookingSlot >= breakTimeMinArray[i].end && nextBookingSlot < breakTimeMinArray[i + 1].start) {
        hour = ('0' + Math.floor(nextBookingSlot / 60)).slice(-2);
        minute = ('0' + nextBookingSlot % 60).slice(-2);
        str = hour + ':' + minute;
        actualArr.push(str);
        nextBookingSlot = nextBookingSlot + slotDuration;
      } else {
        i++;
        nextBookingSlot = breakTimeMinArray[i].end;
      }
    }
    return actualArr;
  }

  computeMin(breakTimings) {
    const breakStart = breakTimings.start.split(':');
    let breakEnd = breakTimings.end.split(':');
    let breakStartMin = parseInt(breakStart[0]) * 60 + parseInt(breakStart[1]);
    let breakEndMin = parseInt(breakEnd[0]) * 60 + parseInt(breakEnd[1]);
    breakEndMin = breakEndMin == 1439 ? 1440 : breakEndMin;
    breakStartMin = breakStartMin == 1439 ? 1440 : breakStartMin;
    return { start: breakStartMin, end: breakEndMin }
  }

  sortOnBookingStart(breakTImeArray) {
    breakTImeArray.sort(function (a, b) {
      return a.start - b.start;
    });
    return breakTImeArray;
  }

  setMinutes(hourVal, that, min) {
    this.utilityFunctions.setMinutes(hourVal, that, min);
  }

  // 24 hour time slot changes
  setTo24() {
    this.facility.timings.closeTime = this.utilityFunctions.setTo24(this.facility.timings.closeTime);
    this.facility.slotDuration = this.facility.slotDuration == '1439' ? '1440' : this.facility.slotDuration;
    this.facility.peekTimings.forEach(element => {
      element.end = this.utilityFunctions.setTo24(element.end);
    });
    this.facility.breakTimings.forEach(element => {
      element.end = this.utilityFunctions.setTo24(element.end);
    });
  }

  setActivityTimings() {
    this.facility.timings.closeTime = this.facility.timings.closeTime === '24:00:00:00' ? '23:59:00:00' : this.facility.timings.closeTime;
    this.facility.slotDuration = this.facility.slotDuration === '1440' ? '1439' : this.facility.slotDuration;
    this.facility.peekTimings.forEach(element => {
      element.end = element.end === '24:00:00:00' ? '23:59:00:00' : element.end;
    });
    this.facility.breakTimings.forEach(element => {
      element.end = element.end === '24:00:00:00' ? '23:59:00:00' : element.end;
    });
  }

  setFacilityData() {
    this.facility.timezoneOffset = this.vendor.timezoneOffset;
    this.facility.timezoneUTC = this.vendor.timezoneUTC;
    this.facility.timezoneAbbr = this.vendor.timezoneAbbr;
    this.facilityValidationObj.setProperValuesToFacilityObj(this);
    this.facility.slotDuration = this.checkAmenities() ? '0' : this.calculateSlotDuration();
    this.facility.activitySlots = this.facility.isSlotsLocked ? this.calculateBookingStartTimeValues() : [];
    this.facility.amount.currency = this.vendor.country == 'India' ? 'INR' : 'USD';
    this.setActivityTimings();
  }
}



// WEBPACK FOOTER //
// ./src/app/facility/facility-rule/facility-rule.component.ts